<script setup lang="ts">
import type { CheckpointModel } from '@/types/models/CheckpointModel'
import type { ConfigType } from '@/types/models/PartnerConfigModel'
import type { PartnerModel } from '@/types/partners/PartnerModel'
import { EditableTypedInput, StackLayout, TypographyItem } from '@rfc/rfc-components-library'
import { localFallback } from '@rfc/rfc-components-library/locales'
import { type ExtendedPrimitives } from '@rfc/rfc-components-library/types'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const i18n = useI18n()

type Props = {
    editMode?: boolean
    partnerConfig?: PartnerModel
    partnerConfigValue?: Record<string, ExtendedPrimitives> | null
}
const props = defineProps<Props>()
type Emits = {
    (e: 'change', value: Partial<CheckpointModel>): void
}
defineEmits<Emits>()

const config = computed(() => Object.entries(props.partnerConfig?.config?.checkpoint ?? {}))
</script>

<template>
    <StackLayout :gap="8">
        <template v-for="([itemKey, itemValue], key) in config" :key="key">
            <EditableTypedInput
                :label="
                    (itemValue as ConfigType)?.label
                        ? (localFallback((itemValue as ConfigType)?.label, i18n) ?? itemKey)
                        : itemKey
                "
                :modelValue="partnerConfigValue?.[itemKey]"
                :dataType="(itemValue as ConfigType)?.type ?? itemValue"
                :editMode="editMode"
                required
                @change="$emit('change', { partner_config: { [itemKey]: $event } })" />
            <TypographyItem v-if="key !== config.length" />
        </template>
    </StackLayout>
</template>
